
export default class ReceiptLinePalletEditorModel {
    constructor(id, qty){
        this.glasschainId = id || "";
        this.actualPalletUnitQty = qty || 0;


    }
}